import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", ": 12px;\n  font-size: 22px;\n  color: ", ";\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  z-index: ", ";\n  ", ";\n  color: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  height: ", ";\n  z-index: 2;\n\n  ", "\n\n  ", "\n\n  position: absolute;\n  top: 0px;\n  padding: 0px;\n  margin: ", ";\n  ", "\n  border: 0px;\n  outline: none;\n  background: none;\n  color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  height: 100%;\n  flex: 1 1 auto;\n  z-index: 1;\n  max-width: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  & * {\n    box-sizing: border-box;\n  }\n  ", "\n  position: relative;\n  ", "\n  height: ", ";\n  padding: ", ";\n\n  border-radius: ", ";\n  border: ", ";\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState, forwardRef, useRef } from 'react';
import styled from 'styled-components';
import { HelperText } from './InputStyles';
import { opposite, centeredFlexHorizontal } from '../../../shared/css';
import { elementHasProp, ItemMargin } from '../../../shared';
import useOptionallyControlledInput from '../utils/useOptionallyControlledInput';
import inputWidth from '../utils/inputWidth';
var BoxContainer = styled.div(_templateObject(), centeredFlexHorizontal, inputWidth, function (p) {
  return p.multiline ? '175px' : p.theme.spacing(7);
}, function (p) {
  return p.isFocused || p.hasError ? p.theme.spacing(0, 2) : '1px 17px';
}, function (p) {
  return p.theme.spacing(0.5);
}, function (p) {
  if (p.hasError) return "2px solid ".concat(p.theme.danger);
  if (p.disabled) return "1px solid ".concat(p.theme.grey4);
  if (p.isFocused) return "2px solid ".concat(p.theme.info);
  if (p.isComplete) return "1px solid ".concat(p.theme.text);
  return "1px solid ".concat(p.theme.grey4);
}, function (_ref) {
  var isFocused = _ref.isFocused,
      theme = _ref.theme;
  return isFocused && "color: ".concat(theme.info, ";");
});
var InputContainer = styled.div(_templateObject2());
export var DOMInput = styled.input.attrs({
  placeholder: ''
})(_templateObject3(), function (p) {
  return p.multiline ? '141px' : '20px';
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled && 'cursor: not-allowed;';
}, function (p) {
  return p.theme.fontCss('displaySmall');
}, function (_ref3) {
  var hasLabel = _ref3.hasLabel,
      isLabelShrunk = _ref3.isLabelShrunk;
  return hasLabel && isLabelShrunk ? '25px 0px 7px 0px' : '17px 0px';
}, function (_ref4) {
  var hasLeftIcon = _ref4.hasLeftIcon,
      hasRightIcon = _ref4.hasRightIcon;
  var leftDiff = hasLeftIcon ? 10 : 0;
  var rightDiff = hasRightIcon ? 10 : 0;
  return "\n        width: calc(100% + ".concat(leftDiff + rightDiff, "px);\n        left: -").concat(leftDiff, "px;\n        margin-left: ").concat(leftDiff, "px;\n        margin-right: ").concat(rightDiff, "px;\n      ");
}, function (_ref5) {
  var isComplete = _ref5.isComplete,
      disabled = _ref5.disabled,
      theme = _ref5.theme;
  if (disabled) return theme.grey3;
  if (isComplete) return theme.text;
  return theme.grey3;
});
var Label = styled.label(_templateObject4(), function (p) {
  return p.theme.fontCss('displaySmall');
}, function (p) {
  return p.isLabelShrunk ? '3' : '-1';
}, function (_ref6) {
  var isLabelShrunk = _ref6.isLabelShrunk,
      isComplete = _ref6.isComplete;
  if (isLabelShrunk) return "\n        height: 5px;\n        align-self: flex-start;\n        font-size: 14px;\n        font-weight: bold;\n      ";
  if (isComplete) return 'display: none;';
  return "\n      display: flex;\n      height: 52px;\n      align-items: center;\n    ";
}, function (p) {
  if (p.hasError) return p.theme.danger;
  if (p.isFocused) return p.theme.info;
  if (p.disabled && p.isComplete) return p.theme.text;
  return p.theme.grey3;
});
var Icon = styled(function (_ref7) {
  var icon = _ref7.icon,
      className = _ref7.className;
  return icon ? /*#__PURE__*/React.createElement("div", {
    className: className
  }, icon) : null;
})(_templateObject5(), function (_ref8) {
  var position = _ref8.position;
  return "margin-".concat(opposite(position));
}, function (p) {
  return p.theme.grey3;
}, function (_ref9) {
  var icon = _ref9.icon;
  return elementHasProp(icon, 'onClick') && "cursor: pointer; z-index: 2;";
});
var BasicInput = forwardRef(function (_ref10, ref) {
  var label = _ref10.label,
      helperText = _ref10.helperText,
      hasError = _ref10.hasError,
      width = _ref10.width,
      children = _ref10.children,
      leftIcon = _ref10.leftIcon,
      rightIcon = _ref10.rightIcon,
      inputRefProp = _ref10.inputRef,
      _ref10$allowLabelShri = _ref10.allowLabelShrink,
      allowLabelShrink = _ref10$allowLabelShri === void 0 ? true : _ref10$allowLabelShri,
      _ref10$alwaysLabelShr = _ref10.alwaysLabelShrink,
      alwaysLabelShrink = _ref10$alwaysLabelShr === void 0 ? false : _ref10$alwaysLabelShr,
      _ref10$uncontrolled = _ref10.uncontrolled,
      uncontrolled = _ref10$uncontrolled === void 0 ? false : _ref10$uncontrolled,
      className = _ref10.className,
      inputComponent = _ref10.inputComponent,
      multiline = _ref10.multiline,
      style = _ref10.style,
      margin = _ref10.margin,
      explicitInputProps = _ref10.inputProps,
      inputProps = _objectWithoutProperties(_ref10, ["label", "helperText", "hasError", "width", "children", "leftIcon", "rightIcon", "inputRef", "allowLabelShrink", "alwaysLabelShrink", "uncontrolled", "className", "inputComponent", "multiline", "style", "margin", "inputProps"]);

  var defaultInputRef = useRef();
  var inputRef = inputRefProp || defaultInputRef;

  var _useOptionallyControl = useOptionallyControlledInput(inputProps, {
    uncontrolled: uncontrolled
  }),
      value = _useOptionallyControl.value,
      onChange = _useOptionallyControl.onChange;

  var isComplete = !!value;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setIsFocused = _useState2[1];

  var isLabelShrunk = allowLabelShrink && (alwaysLabelShrink || isComplete || isFocused);
  var shouldShowLabel = label && (allowLabelShrink || !isLabelShrunk);
  var stylingProps = {
    hasError: hasError,
    isLabelShrunk: isLabelShrunk,
    disabled: inputProps.disabled,
    isComplete: isComplete,
    isFocused: isFocused,
    width: width
  };
  return /*#__PURE__*/React.createElement(ItemMargin, {
    margin: margin
  }, /*#__PURE__*/React.createElement(BoxContainer, _extends({}, stylingProps, {
    ref: ref
  }, {
    className: className,
    style: style,
    multiline: multiline
  }), /*#__PURE__*/React.createElement(Icon, {
    icon: leftIcon,
    position: "left"
  }), /*#__PURE__*/React.createElement(InputContainer, {
    className: "inputContainer"
  }, shouldShowLabel && /*#__PURE__*/React.createElement(Label, _extends({
    htmlFor: inputProps.name,
    id: "".concat(inputProps.name, "-label")
  }, stylingProps), label), /*#__PURE__*/React.createElement(DOMInput, _extends({}, stylingProps, inputProps, explicitInputProps, {
    value: value,
    onChange: onChange,
    multiline: multiline
  }, {
    as: multiline ? 'textarea' : inputComponent
  }, multiline && {
    rows: 5
  }, {
    ref: inputRef,
    id: inputProps.name,
    hasLabel: !!label,
    onFocus: function onFocus() {
      setIsFocused(true);
      if (inputProps.onFocus) inputProps.onFocus.apply(inputProps, arguments);
    },
    onBlur: function onBlur() {
      setIsFocused(false);
      if (inputProps.onBlur) inputProps.onBlur.apply(inputProps, arguments);
    },
    hasLeftIcon: !!leftIcon,
    hasRightIcon: !!rightIcon,
    "aria-labelledby": "".concat(inputProps.name, "-label")
  }), children)), /*#__PURE__*/React.createElement(Icon, {
    icon: rightIcon,
    position: "right"
  })), helperText && /*#__PURE__*/React.createElement(HelperText, {
    hasError: hasError
  }, helperText));
});
export default BasicInput;